import { useEffect } from 'react'
import { ensureSearchIndex } from '../lib/searchIndexStore'

// Loads the global search index on idle after boot, so the first search is
// instant — and so it's on disk before someone walks into a festival with no signal.
export function useWarmSearchIndex() {
  useEffect(() => {
    const warm = () => { if (navigator.onLine) void ensureSearchIndex() }
    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(warm)
      return () => window.cancelIdleCallback(id)
    }
    const id = setTimeout(warm, 4000)
    return () => clearTimeout(id)
  }, [])
}
